import React from "react";

import generateGridMediaStyles from "./generateGridMediaStyles";

interface ColProps {
  as?: string | React.ElementType;
  width?: number | number[];
  children: React.ReactNode;
  [key: string]: any;
}


export default function Col(props: ColProps) {

  const returnFlexBasis = (val: number) => ({
    flexBasis: `${Number(val * 100).toFixed(2)}%`,
    maxWidth: `${Number(val * 100).toFixed(2)}%`
  });

  const {
    as = "div",
    width,
    children,
    ...otherProps
  } = props;

  const Tag = as;

  return (
    <Tag
      css={[
        {
          flexGrow: 0,
          flexShrink: 1
        },
        generateGridMediaStyles(width, returnFlexBasis)
      ]}
      {...otherProps}>

      {children}

    </Tag>
  );
}
